import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmitNewTranslation?: () => void;
  showSubmitNewTranslation?: boolean;
};

const EnglishStringInfoDialog: React.FC<Props> = ({ open, onClose, onSubmitNewTranslation = () => {}, showSubmitNewTranslation = false }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      slotProps={{
        paper: {
          sx: {
            border: 2,
            borderColor: 'primary.main',
            borderRadius: 2,
          },
        },
      }}>
      <DialogTitle sx={{ fontWeight: 700 }}>Editing English strings</DialogTitle>

      <DialogContent>
        <Typography gutterBottom sx={{ mb: 3 }}>
          We currently use natural language keys to identify our English strings. This means that you cannot edit an English string because that would break implementation.
        </Typography>

        <Typography gutterBottom sx={{ mb: 3 }}>
          For example <b>&lt;I'm-outside-of-Texas&gt;</b> and <b>&lt;I-am-outside-of-Texas&gt;</b> are two different strings code wise. Despite meaning the exact same thing, the character differences designate them as separate keys.
        </Typography>

        <Typography gutterBottom sx={{ mb: 3 }}>
          If you want to change an English string, you should instead submit a new string with updated English text and the appropriate translation. Then your developers can swap the necessary strings in the code.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'flex-end' }}>
        {showSubmitNewTranslation && (
          <Button variant="text" onClick={onSubmitNewTranslation}>
            SUBMIT NEW TRANSLATION
          </Button>
        )}
        <Button variant="contained" onClick={onClose}>
          CLOSE
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EnglishStringInfoDialog;
